module.exports = __webpack_public_path__ + "static/media/github.ed8fbbf6.svg";